
import { Button } from 'element-ui'

export default {
  extends: Button,
}
